import { AuthService } from '../../shared/services/auth.service';
import { ToastrService } from 'ngx-toastr';
import { IAccount } from '../../_models/Account/user';
import { Component, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';

@Component({
  selector: 'app-account-form',
  templateUrl: './account-form.component.html'
})
export class AccountFormComponent implements OnInit {
  loading: boolean;
  profile: IAccount;
  profileForm: FormGroup;

  constructor(
    private authService: AuthService,
    private toastrService: ToastrService,
    private fb: FormBuilder) {

  }

  ngOnInit(): void {
    this.createProfileForm();
    this.getProfile();
  }

  getProfile() {
    this.authService.getProfile().subscribe((response: IAccount) => {
      if (response) {
        this.profile = response;
        this.setValueProfileForm();
      }
    });
  }

  submit() {
    if (this.profileForm.valid) {
      this.loading = true;
      this.profile = Object.assign({}, this.profileForm.getRawValue());
      this.authService.editAccount(this.profile).subscribe((response: any) => {
        if (response) {
          this.toastrService.success("Saved successfully.");
        }
      },
        (error) => console.log('HTTP Error', error),
        () => this.loading = false
      );
    }
  }

  createProfileForm() {

    this.profileForm = this.fb.group({
      id: ['', Validators.required],
      shalaId: ['', [Validators.required, Validators.pattern(/^([0-9]{10})([0-9]){0,1}$/)]],
      phoneNumber: ['', Validators.required],
      email: ['', [Validators.required, Validators.email]],
    });

    if (this.profile) {
      this.setValueProfileForm();
    }
  }

  setValueProfileForm() {
    this.profileForm.patchValue({
      id: this.profile.id,
      shalaId: this.profile.shalaId,
      phoneNumber: this.profile.phoneNumber,
      email: this.profile.email
    });
  }

}
